// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createStateHook } from '@atlassian/react-sweet-state';
import { layoutStore } from '../../store/index.tsx';

export const usePreviewPanelState = createStateHook(layoutStore, {
	selector: (state) => ({
		...state.content.previewPanel,
	}),
});
